/* eslint-env jquery */

import { JqueryColorbox } from 'jquery-colorbox/jquery.colorbox'; // eslint-disable-line no-unused-vars, import/no-unresolved

import { M6FormValidation } from 'M6/form_validation/jquery.form_validation'; // eslint-disable-line no-unused-vars, import/no-unresolved, import/extensions

import { GazeboBuilderClient } from '../gazebo-builder/gazebo-builder-client';

export class BuilderClient {
    /**
     * Initialize the app on dom content loaded.
     */

    /* eslint-disable-next-line max-lines-per-function */
    dom() {
        // Initialize Gazebo Builder
        // ---------------------------------------------------------------------
        /* eslint-disable-next-line max-statements */
        jQuery(($) => {
            const gbNodes = document.querySelectorAll('.gazebo-builder');
            for (let i = 0; i < gbNodes.length; ++i) {
                const gbNode = gbNodes[i];
                const builder = new GazeboBuilderClient(gbNode);

                // Form Validation
                // -------------------------------------------------------------
                if ($().formValidation) {
                    // Remove the on_success field and perform the
                    // form POST via ajax with CORS.

                    const gbForm = $('.gb-form');

                    const gbBuilder = gbForm.find('.gazebo-builder');

                    gbForm.find('input[name="form_ctrl[on_error]"]').remove();

                    gbForm.find('input[name="form_ctrl[on_success]"]').remove();

                    gbForm.formValidation({
                        errorPosition: 'right',
                        showErrorSummary: false,
                        onSuccess() {
                            // onSuccess is only set to
                            // force an ajax style form submission.
                        },
                        onValid() {
                            const successRedirect = $(gbBuilder).data(
                                'gazeboBuilderUserProfile'
                            );
                            if (
                                typeof successRedirect !== 'undefined' &&
                                typeof successRedirect.success_redirect ===
                                    'string' &&
                                successRedirect.success_redirect.toString() !==
                                    ''
                            ) {
                                window.location.href =
                                    successRedirect.success_redirect;

                                return;
                            }

                            // formerly the criteria were:
                            // window.location.hostname === 'www.gazebo.com' ||
                            // window.location.hostname === 'gazebo.com'
                            // Did the hostname change?
                            // I toyed with the idea of
                            // window.location.hostname === window.location.hostname
                            // but that seems insecure.
                            // So, now we check in configurator.php whether the hostname is a whitelisted domain.
                            // In order for this to work (I hope), country_lane__user_profile.domain
                            // needs to be set with this domain.

                            // whiteListedDomains is assigned in configurator.php and is a trimmed
                            // set of a user's profile's domains

                            // whiteListedDomains is only defined in the head of
                            // configurator.php
                            if (window.whiteListedDomains != null) {
                                if (
                                    window.whiteListedDomains.includes(
                                        window.location.hostname
                                    )
                                ) {
                                    window.location.href =
                                        'https://www.gazebo.com/build/thank-you/';

                                    return;
                                }
                            }

                            // the builder snippet seems to be builder.js,
                            // and is defined in js.html
                            // if (window.domain != null) {
                            //     console.log(window.domain);
                            //     if (window.domain = window.location.hostname) {
                            //         window.location.href =
                            //             'https://www.gazebo.com/build/thank-you/';

                            //         return;
                            //     }
                            // }

                            builder.changeStep('thanks');
                        },
                    });
                }
            }
        });

        // Enlarge Image
        // ---------------------------------------------------------------------
        jQuery(($) => {
            $('.gb-enlarge').click((e) => {
                e.preventDefault();

                const conf = {
                    onComplete() {
                        $('#cboxOverlay, #colorbox, .cboxPhoto').click(() => {
                            $.colorbox.close();
                        });
                    },
                    html: $('.gb-preview-img-container').html(),
                    className: 'gb-colorbox',
                    initialWidth: '250px',
                    initialHeight: '250px',
                    maxWidth: '1280px',
                    maxHeight: '540px',
                    close: '×',
                    speed: 0,
                };

                if ($(window).width() > 800) {
                    conf.width = '90%';
                } else {
                    const imgWidth = $(window).width() * 2;
                    conf.width = `${imgWidth}px`;
                }

                $.colorbox(conf);
            });
        });

        // Dynamic form
        jQuery(($) => {
            $('select[name="opportunity_type"]').change((e) => {
                const contractorForm = $('.contractor');
                const contractorFormFields = $(
                    '.contractor input, .contractor select, .contractor textarea'
                );
                const customerForm = $('.customer');
                const customerFormFields = $(
                    '.customer input, .customer select, .customer textarea'
                );
                if (e.target.value == 2) {
                    contractorForm.show();
                    customerForm.hide();
                    contractorFormFields.prop('disabled', false);
                    customerFormFields.prop('disabled', true);
                } else {
                    contractorForm.hide();
                    customerForm.show();
                    contractorFormFields.prop('disabled', true);
                    customerFormFields.prop('disabled', false);
                }
            });
        });
    }
}
